var map = {
	"./azure.png": 5754,
	"./css3.png": 2395,
	"./d3.png": 9672,
	"./databricks.png": 185,
	"./fastapi.png": 6673,
	"./firebase.png": 7756,
	"./flask.png": 698,
	"./git.png": 319,
	"./github.png": 1442,
	"./html5.png": 7407,
	"./java.png": 991,
	"./javascript.png": 8102,
	"./linux.png": 4077,
	"./matplotlib.png": 971,
	"./mlflow.png": 4716,
	"./mongodb.png": 2753,
	"./mssql.png": 2327,
	"./mysql.png": 7117,
	"./node.png": 4923,
	"./numpy.png": 4398,
	"./pandas.png": 6972,
	"./plotly.png": 6255,
	"./powerbi.png": 983,
	"./python.png": 1025,
	"./pytorch.png": 546,
	"./react.png": 2450,
	"./seaborn.png": 6687,
	"./sklearn.png": 8311,
	"./spark.png": 3224,
	"./sql.png": 7739,
	"./streamlit.png": 4468,
	"./vertica.png": 1993,
	"./xgboost.png": 9891
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3759;